import React from 'react'
import newExperience from 'static/new_experience.png'

function NewEngageBanner() {
  return (
    <div className='new-engage-experience-banner-wrapper'>
      <div className='new-engage-experience-banner'>
        <div className='image'>
          <img src={newExperience} alt='New Engage Experience' />
        </div>
        <div className='new-engage-content'>
          <h3>A fully integrated Engage experience is here!</h3>
          <div>
            All engagement features are now available in 15Five, providing you
            with a centralized way to identify opportunities, plan actions, and
            enhance engagement, performance, and retention. While you can still
            access legacy reporting from the Engage portal, you must create and
            view results for new campaigns directly in 15Five.
            <br />
          </div>
        </div>
        <div className='new-engage-learn-more'>
          <a href='https://success.15five.com/hc/en-us/articles/31267130138139-Timeline-for-sunsetting-legacy-engagement-tools'>
            Learn more
          </a>
        </div>
      </div>
    </div>
  )
}

export default NewEngageBanner
